import { Link } from "react-router-dom";
import { WebpHeaderPattern } from "../assets";

export default function MegaMenuContent({ data, onClickAway }) {
  return (
    <div className="megamenu__content__column__content__wrapper">
      <img
        loading="lazy"
        className="megamenu__content__column__content__img"
        src={WebpHeaderPattern}
        alt={data?.title}
      />
      <Link
        to={data?.contentLink}
        className="megamenu__content__column__content"
      >
        <div className="megamenu__content__column__title">{data?.title}</div>
        <div className="megamenu__content__column__info">{data?.content}</div>
        <Link
          to={data?.contentLink}
          onClick={onClickAway}
          className="megamenu__content__column__btn"
        >
          Learn more
        </Link>
      </Link>
      <div className="megamenu__content__img">
        <img
          style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
          }}
          loading="lazy"
          src={data?.img}
          alt=" 

 img"
        />
      </div>
    </div>
  );
}
